<template>
  <footer class="footnote">
    <div class="footnote-container">
      <div class="contact-info">
        <h3>CONTACT</h3>
        <p><a href="mailto:idesign16@gmail.com">Email: idesign16@gmail.com</a></p>
        <p><a href="tel:+15714899960">Phone: +1 571 489 9960</a></p>

      </div>
      <div class="contact-form">
        <h3>GET IN TOUCH</h3>
        <form @submit.prevent="submitForm">
          <label for="name">Name:</label>
          <input type="text" id="name" v-model="form.name" required />

          <label for="email">Email:</label>
          <input type="email" id="email" v-model="form.email" required />

          <label for="message">Description:</label>
          <textarea id="message" v-model="form.message" required></textarea>

          <button type="submit">Contact Now</button>
        </form>
      </div>
      <div class="other">
        <h3>OTHER</h3>
        <p><router-link to="/about" @click="scrollToTop">About Us</router-link></p>
        <p><router-link to="/projects" @click="scrollToTop">Projects</router-link></p>
      </div>
    </div>
    <div class="footer-bottom">
      <a>
        Copyright &copy; 2025 Golden MS LLC All Rights Reserved.
      </a>
    </div>
  </footer>
</template>

<script>
import emailjs from 'emailjs-com';

export default {
  name: 'FootNote',
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      }
    };
  },
  methods: {
    async submitForm() {
      try {
        const serviceID = 'service_wcbidgp'; 
        const templateID = 'template_fdas46b';
        const userID = 'mtNrUoEGciBHXKPvh';

        const templateParams = {
          name: this.form.name,
          email: this.form.email,
          message: this.form.message
        };

        await emailjs.send(serviceID, templateID, templateParams, userID);
        alert('I have received your message. I will get back to you as soon as possible.');

        this.form.name = '';
        this.form.email = '';
        this.form.message = '';
      } catch (error) {
        console.error('Failed to send message:', error);
        alert('Failed to send message. Please try again later.');
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style scoped>
.footnote {
  background-color: #1C1C1C;
  color: white;
  padding: 2rem;
  overflow-x: hidden; 
}

.footnote-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1500px;
  margin: 0 auto;
  width: 100%; 
  box-sizing: border-box; 
}

.contact-form {
  max-width: 400px;
  flex: 1;
  text-align: left;
}

.contact-form h3 {
  margin-bottom: 1rem;
}

.contact-form label {
  display: block;
  margin: 0.5rem 0 0.2rem;
  color: rgb(175, 173, 173);
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 0.5rem 0; 
  margin-bottom: 1rem;
  border: none; 
  border-bottom: 2px solid #FFB606; 
  border-radius: 0; 
  background: transparent; 
  color: white; 
}

.contact-form textarea {
  resize: none;
}

.contact-form input:focus,
.contact-form textarea:focus {
  outline: none; 
  border-bottom: 2px solid #FFD700;
}

.contact-form button {
  background-color: #ffffff;
  color: black;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.contact-form button:hover {
  background-color: #c4c1c1a8;
}

.contact-info {
  flex: 1;
  max-width: 300px;
  text-align: left;
}
.contact-info h3 {
  margin-bottom: 1rem;
}

.contact-info p {
  margin: 0 0 1rem;
  color: rgb(175, 173, 173) 
}

.contact-info a {
  color: inherit; 
  text-decoration: none; 
}

.other {
    flex: 1;
    max-width: 300px;
    text-align: left;
}
.other p {
  color: rgb(175, 173, 173);
}
.other a {
  text-decoration: none; 
  color: inherit;
}

.other a:hover {
  text-decoration: none; 
  color: inherit; 
}
.footer-logo {
  width: 15px; 
  height: 15px;
  margin-right: 5rem;
}
.footer-bottom {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 2rem;
  padding-bottom: 0;
  color: rgb(175, 173, 173);
  width: 100%; 
  box-sizing: border-box; 
  transform: translateY(165%);
}

@media (max-width: 768px) {
  .footnote-container {
    flex-direction: column; 
    gap: 1.5rem; 
  }

  .contact-info,
  .contact-form,
  .other {
    margin-bottom: 1.5rem; 
  }
  .footer-bottom {
    transform: translateY(20%);
    margin-top: 1rem;
  }
}

</style>